import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/sign-in/[[...rest]]/page.tsx");
